export const LeasePaymentReqRouting = [
  {
    path: "/lease-config/lease-payment-req/list",
    name: "lease-payment-req-list",
    meta: { title: "租赁付款申请" },
    component: () => import("@/views/lease-config/lease-payment-req/list/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-payment-req/create",
    name: "lease-payment-req-create",
    meta: { title: "新增租赁付款申请",comName:"leaseConfigLeasePaymentReqFormCreate"  },
    component: () =>
      import("@/views/lease-config/lease-payment-req/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-payment-req/edit/:id",
    name: "lease-payment-req-edit",
    meta: { title: "编辑租赁付款申请",comName:"leaseConfigLeasePaymentReqFormCreate"  },
    component: () =>
      import("@/views/lease-config/lease-payment-req/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-payment-req/detail/:id",
    name: "lease-payment-req-detail",
    meta: { title: "租赁付款申请详情" },
    component: () =>
      import(
        "@/views/lease-config/lease-payment-req/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/lease-config/lease-payment-req/flowPrint/:id",
    name: "lease-payment-req-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        "@/views/lease-config/lease-payment-req/flow-print/index.vue"
      ),
  },
];